import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import LoadingButton from '@/components/ui/LoadingButton/LoadingButton.tsx';
import { useTranslation } from 'react-i18next';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import DeleteIcon from '@mui/icons-material/Delete';
import useRestaurantDelete from '@/api/useRestaurantDelete.ts';

type DeleteRestaurantModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  selectedElement: number | null | undefined;
};

function DeleteRestaurantModal({ isOpen, onClose, onConfirm, selectedElement }: DeleteRestaurantModalProps) {
  const { t } = useTranslation();
  const {
    mutateAsync: deleteRestaurant,
    isError: isErrorDeleteRestaurant,
    isPending: isLoadingDeleteRestaurant,
    isSuccess: isSuccessDeleteRestaurant,
    error: errorDeleteRestaurant,
  } = useRestaurantDelete();

  const handleDeleteRestaurant = async () => {
    if (!selectedElement) return;
    try {
      await deleteRestaurant({ ids: [selectedElement] });
      if (onConfirm) {
        onConfirm();
      }
      onClose();
    } catch (error) {
      console.error('Error deleting restaurant: ', error);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('modals.deleteRestaurant.title')}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-2 empty:hidden mb-2">
          {isSuccessDeleteRestaurant && <Alert severity="success">{t('modals.deleteRestaurant.successMessage')}</Alert>}
          {isErrorDeleteRestaurant && <Alert severity="error">{errorDeleteRestaurant?.message as string}</Alert>}
        </div>
        <DialogContentText>{t('modals.deleteRestaurant.info')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-wrap grow p-4 pt-0 justify-between">
          <BackButton onClick={onClose} autoFocus />
          <LoadingButton
            startIcon={<DeleteIcon />}
            loading={isLoadingDeleteRestaurant}
            color="error"
            variant="contained"
            onClick={handleDeleteRestaurant}
          >
            {t('button.delete')}
          </LoadingButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteRestaurantModal;
